import '../../index.css';
var styles = {
  "iconButton": "bp_icon_button_module_iconButton--81053",
  "icon": "bp_icon_button_module_icon--81053",
  "default": "bp_icon_button_module_default--81053",
  "icon-logo": "bp_icon_button_module_icon-logo--81053",
  "high-contrast": "bp_icon_button_module_high-contrast--81053",
  "small-utility": "bp_icon_button_module_small-utility--81053",
  "large": "bp_icon_button_module_large--81053",
  "small": "bp_icon_button_module_small--81053",
  "x-small": "bp_icon_button_module_x-small--81053"
};
export { styles as default };